
import React from 'react'
import './template.css'
import './template_desktop.css'
import { FooterLayout } from './PageLayout'
import { socialMediaLinksGenerator } from "./SocialMediaLinks";
import CircularProgress from '@mui/material/CircularProgress';
import Container from 'react-bootstrap/Container';


export const HideableView = ({ className, isVisible, children }) => {
    const hiddenStyle = { display: 'none' }
    return (
        <div
            className={className}
            style={isVisible ? { display: 'block' } : hiddenStyle}>
            {children}
        </div>
    )
}

export function LogoBanner({ }) {
    return (
        <Container className="logo-banner">
            <img className="logo-banner" src="/img/brand/crochetedly_logo.jpg" />
        </Container>
    )
}

export const IconNotProvided = (iconName) => <span>{iconName} icon not provided</span>

export function IconLink({ url, children }) {
    return <a href={url} className="icon-wrapper icon-link" target="_blank" rel="noopener noreferrer" >{children}</a>
}

export function ContactIconLinksList({ children }) {
    return (
        <ul className="icon-links-list">
            {React.Children.map(children, child =>
                <li className="icon-links-list">{child}</li>)}
        </ul>
    )
}

export const TikTokIcon = ({ color = "#000000" }) => {
    return (
        <svg fill={color}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-3 -3 55 55"
            width="100%"
            height="100%">
            <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
        </svg>
    );
}


export const EtsyIcon = ({ color = "#000000" }) => {
    return (
        <svg fill={color}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-2 0 50 24"
            width="100%"
            height="100%">
            <path d="M6.547,3.125v6.008c0,0,2.117,0,3.25-0.086c0.891-0.156,1.055-0.242,1.219-1.133l0.328-1.305h0.969l-0.164,2.852 l0.086,2.922h-0.977l-0.242-1.141c-0.242-0.812-0.57-0.977-1.219-1.055c-0.812-0.086-3.25-0.086-3.25-0.086v5.039 c0,0.969,0.492,1.383,1.625,1.383h3.414c1.055,0,2.109-0.086,2.766-1.625l0.883-1.953h0.82c-0.086,0.406-0.492,3.984-0.57,4.789 c0,0-3.086-0.078-4.383-0.078H5.25l-3.492,0.078v-0.883l1.133-0.25c0.82-0.164,1.062-0.406,1.062-1.055 c0,0,0.086-2.195,0.086-5.852c0-3.648-0.086-5.844-0.086-5.844c0-0.727-0.242-0.891-1.062-1.055L1.758,2.555V1.664l3.414,0.07h6.5 c1.297,0,3.484-0.234,3.484-0.234s-0.078,1.375-0.164,4.625h-0.891l-0.328-1.141c-0.32-1.461-0.805-2.188-1.703-2.188H6.961 C6.547,2.797,6.547,2.875,6.547,3.125z M19.703,3.766h0.977V7.18l3.336-0.164l-0.164,1.547l-3.25-0.25v6.016 c0,1.703,0.57,2.359,1.547,2.359c0.883,0,1.539-0.492,1.781-0.898l0.484,0.57c-0.484,1.133-1.859,1.703-3.164,1.703 c-1.617,0-2.93-0.969-2.93-2.836V8.398h-1.938V7.586C18.008,7.422,19.219,6.445,19.703,3.766z M26.695,14.242l0.648,1.547 c0.242,0.648,0.812,1.305,2.109,1.305c1.383,0,1.953-0.734,1.953-1.625c0-2.766-5.445-1.953-5.445-5.688c0-2.109,1.703-3.094,3.898-3.094c0.977,0,2.438,0.164,3.172,0.492c-0.164,0.812-0.25,1.867-0.25,2.68l-0.805,0.078l-0.57-1.625 c-0.164-0.398-0.82-0.727-1.625-0.727c-0.977,0-1.953,0.406-1.953,1.461c0,2.516,5.609,1.953,5.609,5.688c0,2.117-1.867,3.25-4.148,3.25c-1.703,0-3.414-0.656-3.414-0.656c0.164-0.969,0.086-2.023,0-3.086H26.695z M33.031,22.039 c0.242-0.891,0.406-2.023,0.57-3.086l0.891-0.078l0.328,1.703c0.078,0.406,0.32,0.734,0.969,0.734c1.055,0,2.438-0.648,3.742-2.922 c-0.578-1.383-2.281-5.844-3.828-9.258c-0.406-0.898-0.484-0.977-1.047-1.141l-0.414-0.156v-0.82l2.445,0.086l3-0.164V7.75 l-0.734,0.164c-0.57,0.078-0.805,0.398-0.805,0.727c0,0.086,0,0.164,0.078,0.328c0.156,0.492,1.461,4.141,2.438,6.578c0.805-1.703,2.352-5.523,2.594-6.172c0.086-0.328,0.164-0.406,0.164-0.648c0-0.414-0.242-0.656-0.805-0.812L42.039,7.75V6.938 l2.281,0.078l2.109-0.078V7.75l-0.406,0.32c-0.812,0.328-0.898,0.406-1.219,1.062l-3.57,8.359 c-2.117,4.797-4.312,5.203-5.852,5.203C34.406,22.695,33.672,22.445,33.031,22.039z" />
        </svg>
    )
}

export const DPopIcon = ({ color = "#000000" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0,0,256,256"
            fill-rule="nonzero">
            <g transform="translate(-48.64,-48.64) scale(1.38,1.38)">
                <g fill="none"
                    fill-rule="nonzero"
                    stroke="none" stroke-width="1"
                    stroke-linecap="butt"
                    troke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style={{ mixBlendMode: 'normal' }}>
                    <g transform="scale(5.33333,5.33333)">
                        <path d="M27,12v8h-6c-5,0 -8,4.18 -8,8.38c0,4.21 3.82,7.62 8,7.62h13v-24zM27,31h-5c-1.86,0 -3,-1.14 -3,-3c0,-1.86 1.38,-3 3.24,-3h4.76z" fill={color}></path>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export const KoFiIcon = ({ color = "#000000" }) => {

    return (
        <svg width="100%"
            height="100%"
            viewBox="0 0 241 194"
            xmlns="http://www.w3.org/2000/svg">
            <g >
                {/* solved the problem of how to do a path with a hole in it by appending the path 'd' attribute value from one of the inner shapes to that of an outer one */}
                <path d="M15.1975 67.7674C15.1975 37.5285 33.3866 21.164 54.7559 18.4334C70.8987 16.387 90.906 16.1589 114.544 16.1589C151.372 16.1589 160.919 16.6151 174.559 17.9772C206.617 21.1576 225.255 40.937 225.255 69.3577V72.9941C225.255 99.3687 205.932 120.966 179.786 123.234C177.74 130.058 174.559 136.874 170.238 143.698C160.235 159.156 140.228 178.707 103.4 178.707H96.1264C66.1155 178.707 42.9277 165.751 29.0595 142.107C16.7814 121.422 15.1912 98.4563 15.1912 67.7674 M32.2469 67.9899C32.2469 97.3168 34.0654 116.184 43.6127 133.689C54.5225 153.924 74.3018 161.653 96.8117 161.653H103.857C133.411 161.653 147.736 147.329 155.693 134.829C159.558 128.462 162.966 121.417 164.784 112.547L166.147 106.864H174.332C192.521 106.864 208.208 92.09 208.208 73.2166V69.8082C208.208 48.6669 195.024 37.5228 172.058 34.7987C159.102 33.6646 151.372 33.2084 114.538 33.2084C89.7602 33.2084 72.0272 33.4364 58.6152 35.4828C39.7483 38.2134 32.2407 48.8951 32.2407 67.9899" fill={color}></path>
                <path d="M166.158 83.6801C166.158 86.4107 168.204 88.4572 171.841 88.4572C183.435 88.4572 189.802 81.8619 189.802 70.9523C189.802 60.0427 183.435 53.2195 171.841 53.2195C168.204 53.2195 166.158 55.2657 166.158 57.9963V83.6866V83.6801Z" fill={color}></path>
                <path d="M54.5321 82.3198C54.5321 95.732 62.0332 107.326 71.5807 116.424C77.9478 122.562 87.9515 128.93 94.7685 133.022C96.8147 134.157 98.8611 134.841 101.136 134.841C103.866 134.841 106.134 134.157 107.959 133.022C114.782 128.93 124.779 122.562 130.919 116.424C140.694 107.332 148.195 95.7383 148.195 82.3198C148.195 67.7673 137.286 54.8115 121.599 54.8115C112.28 54.8115 105.912 59.5882 101.136 66.1772C96.8147 59.582 90.2259 54.8115 80.9001 54.8115C64.9855 54.8115 54.5256 67.7673 54.5256 82.3198" fill={color}></path>
            </g>
        </svg>
    )
}

export function ShopHereBtn() {
    return <div className="shop-here-btn">
        <a href="https://ko-fi.com/crochetedly/shop" className="shop-here-btn" target="_blank" rel="noopener noreferrer" >SHOP HERE</a>
    </div>
}


export const DefaultPageFooter = () => {
    return (
        <FooterLayout>
            <ContactIconLinksList>
                {socialMediaLinksGenerator()}
            </ContactIconLinksList>
        </FooterLayout>
    )
}

function ViewPlaceholderLayout({ title, details, children }) {
    return (
        <div className="view-placeholder-layout view-placeholder-wrapper">
            {title && <h6>{title}</h6>}
            {details && <div>{details}</div>}
            {children}
        </div>
    )
}

export function LoadingViewPlacholder({ title }) {
    return <ViewPlaceholderLayout title={title} details={null}>
        <br />
        <CircularProgress />
    </ViewPlaceholderLayout>
}

export function ErrorViewPlaceholder({ title, details }) {
    return <div className="view-placeholder-wrapper error-view">
        <h5 style={{ color: "red" }}>{title}</h5>
        {details && <p style={{ color: "red" }}>{details}</p>}
    </div>
}

